export default {
  header: {
    hello: 'Hello {name}',
    connected: 'Connected',
    disconnected: 'Disconnected',
    connectionWarning:
      'Connection issues detected - some features may not work properly',
    conversationId: 'Conversatie ID:',
    language: 'Taal:',
    notAvailable: 'Niet beschikbaar',
    connectionStatus: 'Verbinding status:',
    genesysConnected: 'Verbonden',
    genesysDisconnected: 'Verbroken',
    allConnectionsActive: 'All connections active',
    connectionIssues: 'Connection issues: {issues}',
  },
  app: {
    loggingIn: 'Logging in…',
    pleaseWait: 'Please wait.',
    loginFailed: 'Login failed',
    retry: 'Retry',
    login: 'Login',
    notAuthenticated: 'Not authenticated',
    errorProcessing: 'Error processing message',
    dismiss: 'Dismiss',
    readyToAssist: 'Ready to assist with new customer messages',
    connectionFailed: 'Kon geen verbinding maken met de service',
    processing: 'Bericht van klant verwerken...',
    sending: 'Versturen naar AI-service...',
    generating: 'Pete genereert respons...',
    working: 'Verwerken...',
    generatingShort: 'Genereren...',
    summary: 'Samenvatting',
    activityLog: 'Activiteit',
  },
  middleware: {
    ready: 'Klaar',
    ingesting: 'Gesprek bijwerken…',
    waiting: 'Wachten op volgend bericht…',
    agent_context: 'Agentbericht opgeslagen',
    checking: 'Controleren / stilte gedetecteerd…',
    generating: 'Pete genereert respons…',
    retrying: 'Pete probeert opnieuw (poging {attempt}/{max})…',
    responded: 'Respons klaar',
    summarizing: 'Samenvatting maken…',
    summarized: 'Samenvatting klaar',
    failed: 'Mislukt — opnieuw proberen kan nodig zijn',
    ended: 'Einde gesprek gedetecteerd',
    resumed: 'Hervat gesprek — keuze vereist',
  },
  resume: {
    title: 'Gesprek hervat',
    prompt: 'Deze klant heeft een eerder gesprek. Hoe wil je verdergaan?',
    previousSummary: 'Samenvatting vorig gesprek',
    generatingSummary: 'Samenvatting genereren...',
    noSummary: 'Geen samenvatting beschikbaar.',
    continue: 'Doorgaan',
    new: 'Nieuw gesprek',
    newWithSummary: 'Nieuw + samenvatting als context',
  },
  response: {
    originalMessage: 'Origineel bericht',
    agentResponseTitle: 'Nederlandse reactie voor agenten',
    saveAndTranslate: 'Opslaan & Vertalen',
    translating: 'Vertaling is bezig...',
    edit: 'Bewerken',
    cancel: 'Annuleren',
    translationPlaceholder: 'Voer de Nederlandse vertaling in...',
    customerReply: 'Reactie op bericht in de taal van de klant',
    send: 'Versturen',
    sending: 'Verzenden...',
    sentSuccessfully: 'Succesvol verzonden',
    sendFailed: 'Verzenden mislukt',
    waitingForMessages: 'Wachten op klantberichten',
    waitingForMessagesHint:
      'AI-assistentie verschijnt hier wanneer klanten berichten sturen',
    suggestions: 'Suggesties',
  },
  summary: {
    title: 'Samenvatting',
    generating: 'Samenvatting wordt gegenereerd...',
    error: 'Fout bij genereren samenvatting',
    close: 'Sluiten',
    copy: 'Kopieer samenvatting',
    copied: 'Gekopieerd!',
  },
  articles: {
    related: 'Gerelateerde artikelen',
    viewArticle: 'Bekijk artikel',
  },
  product: {
    info: 'Productinformatie',
  },
};
